<script>
    import RequestDetail from './partials/RequestDetail'
    import {Form} from '../../../helpers/Form/Form'

    export default {
        props: ['requestsprop', 'reservationsCount', 'companyprop', 'requestSource'],
        components: {RequestDetail},
        data() {
            return {
                filteredRequests: [],
                requests: this.requestsprop,
                currentFilter: null,
                orderBy: null,
                selectedRequest: null,
                form: new Form({
                    request_id: null
                })
            }
        },
        computed: {
            requestsCount() {
                return Object.keys(this.requests).length
            },
        },
        mounted() {
            this.getFilteredRequests()
        },
        methods: {
            updateRequest({request}) {
                let message = this.requests[request.subject]
                if (! _.isEmpty(message)) {
                    this.requests[request.subject].unshift(request)
                }
                this.getFilteredRequests()
            },
            clearSelection() {
                this.$set(this, 'selectedRequest', null)
            },
            openRequest(request) {
                this.form.setData('request_id', request.id)

                this.form
                    .submit('put', this.requestSource)
                    .then(({contactRequest}) => {
                        let idx = _.findIndex(this.filteredRequests, i => i.thread == request.thread)
                        this.$set(this.filteredRequests[idx], 'readed_at', contactRequest.readed_at)

                        let requestDetail = this.requests[request.thread]
                        this.$set(this, 'selectedRequest', _.orderBy(requestDetail, ['created_at'], ['asc']))
                    })
            },
            isReaded(request) {
                return !_.isNull(request.readed_at)
            },
            formatDate(request) {
                let requestDetail = _.last(this.requests[request.thread])
                return moment(requestDetail.created_at).format('DD MMM YYYY')
            },
            getFrom(request) {
                let userEmail = request.from != this.companyprop.email ? request.from : request.to

                let user = request.user
                let from = userEmail.split('@')
                return request.user_id ? user.first_name : from[0]
            },
            getFilteredRequests() {
                let requests = []
                for (let idx in this.requests) {
                    let count = this.requests[idx].length
                    let lists = this.requests[idx]

                    requests.push(Object.assign(
                        _.head(this.requests[idx]), {count}
                    ))
                }

                this.$set(this, 'filteredRequests', requests)
            },
            filterIsSelected(filter, option = null) {
                return filter === this.currentFilter && this.orderBy == option
            },
            toggleOrder(filter) {
                if (!_.isEmpty(this.currentFilter)) {
                    if (this.currentFilter != filter) {
                        return 'asc'
                    }
                }

                if (_.isEmpty(this.orderBy)) {
                    return 'asc'
                }

                if (this.orderBy == 'asc') {
                    return 'desc'
                }

                return 'asc'
            },
            applyFilter(filter, value = null) {
                let orderedCollection = []
                this.orderBy = this.toggleOrder(filter)
                this.currentFilter = filter

                if (filter == 'readed_at') {
                    this.orderBy = value ? 'desc' : 'asc'
                    orderedCollection = _.orderBy(this.filteredRequests, [filter], [this.orderBy])
                } else {
                    this.orderBy = value
                    orderedCollection = _.orderBy(this.filteredRequests, [filter], [this.orderBy]);
                }

                this.$set(this, 'filteredRequests', orderedCollection)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Requests.vue